export default __webpack_public_path__ + "static/media/ice-cream.cc2bc7d7.svg";